import { render, staticRenderFns } from "./AnswerPage.vue?vue&type=template&id=39f9d3fc&scoped=true&"
import script from "./AnswerPage.vue?vue&type=script&lang=js&"
export * from "./AnswerPage.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPage.vue?vue&type=style&index=0&id=39f9d3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9d3fc",
  null
  
)

export default component.exports